import { useState } from "react";
import { Icon, Table } from "semantic-ui-react";

import { Option } from "models/Option";
import { CarrierCapacityInfoDto } from "models/dto/CarrierCapacityInfoDto";
import CarrierCapacityTableRowButtons from "../CarrierCapacityTableRowButtons";

import { mapApiToFormObject } from "components/CarrierCapacity/forms/CarrierCapacityForm/utils/carrierCapacityApiToFormMappers";
import CarrierCapacityFormModal from "components/CarrierCapacity/forms/CarrierCapacityForm/CarrierCapacityFormModal";
import { tableDateFormatter } from "../utils/tableDateFormatter";
import { SelectedCarrier } from "models/SelectedCarrier";
import { formatCurrency } from "shared/utils/formatCurrency";

type CarrierPreferredLaneTableRowProps = {
  carrier: SelectedCarrier;
  preferredLane: CarrierCapacityInfoDto<"Preferred Lane">;
  equipmentOptions: Option<number>[];
  reloadCarrierData: () => void;
};

const CarrierPreferredLaneTableRow = (
  props: CarrierPreferredLaneTableRowProps
) => {
  const [isEditingPreferredLane, setIsEditingPreferredLane] = useState(false);

  return (
    <Table.Row key={props.preferredLane.id}>
      <Table.Cell>
        <Icon
          link
          name="edit"
          title="Edit Preferred Lane"
          onClick={() => setIsEditingPreferredLane(true)}
        />
      </Table.Cell>
      <Table.Cell>{props.preferredLane.origin ?? "N/A"}</Table.Cell>
      <Table.Cell>{props.preferredLane.destination ?? "N/A"}</Table.Cell>
      <Table.Cell>
        {props.preferredLane.expirationDate
          ? tableDateFormatter(props.preferredLane.expirationDate)
          : "N/A"}
      </Table.Cell>
      <Table.Cell>
        {props.preferredLane.equipmentModeCategoryId
          ? props.equipmentOptions.find(
              (option) =>
                option.value === props.preferredLane.equipmentModeCategoryId
            )?.text
          : "N/A"}
      </Table.Cell>
      <Table.Cell>
        {props.preferredLane.rate
          ? formatCurrency(props.preferredLane.rate)
          : "N/A"}
      </Table.Cell>
      <Table.Cell>{props.preferredLane.notes || "N/A"}</Table.Cell>
      <Table.Cell>{props.preferredLane.modifiedBy ?? "N/A"}</Table.Cell>
      <Table.Cell>
        {props.preferredLane.id ? (
          <CarrierCapacityTableRowButtons
            carrierId={props.carrier.id}
            capacityId={props.preferredLane.id}
            reloadCarrierData={props.reloadCarrierData}
          />
        ) : null}
      </Table.Cell>

      {isEditingPreferredLane ? (
        <CarrierCapacityFormModal
          carrier={props.carrier}
          equipmentOptions={props.equipmentOptions}
          onClose={() => setIsEditingPreferredLane(false)}
          defaultValues={mapApiToFormObject(props.preferredLane)}
          onSubmitCallback={props.reloadCarrierData}
          originalCapacity={props.preferredLane}
        />
      ) : null}
    </Table.Row>
  );
};

export default CarrierPreferredLaneTableRow;
